/* eslint-disable import/prefer-default-export */
import Immutable from 'seamless-immutable';
import _ from 'lodash';
import * as validateTypes from '../../../../../utils/reducerHalpers/validateTypes';
import {
  getForm,
  createValidateObject,
  storeSetFieldValue,
  storeSetFieldsErrors,
  createField,
  clearErrors
} from '../../../../../utils/reducerHalpers/formFields';
import {
  createRequestState,
  setRequestStateFinish,
  setRequestStateInProgress
} from '../../../../../utils/reducerHalpers/requestState';

const RESET_STATE = 'RESET_STATE';
const CHANGE_SERVICE_ARGS = 'CHANGE_SERVICE_ARGS';

const SEND_FORM_REQUEST = 'SEND_FORM_REQUEST';
const REQUEST_FINISHED = 'REQUEST_FINISHED';

const SET_ERRORS = 'SET_ERRORS';
const CLEAR_ALL_ERRORS = 'CLEAR_ALL_ERRORS';

const CHANGE_FIELD_EMAIL = 'CHANGE_FIELD_EMAIL';
const CHANGE_FIELD_VERIFY_CODE = 'CHANGE_FIELD_VERIFY_CODE';
const CHANGE_MESSAGE = 'CHANGE_MESSAGE';

const createActionName = (reducerName, name) => `app/${reducerName}/${name}`;

const createReducer = name => {
  function stateDefault() {
    return {
      ...createRequestState(),
      serviceArgs: [],
      fields: {
        ...createField({
          field: 'email',
          title: 'Email',
          value: '',
          validate: [createValidateObject(validateTypes.REQUIRED)],
          errors: []
        }),
        ...createField({
          field: 'verify_code',
          title: 'Проверочный код',
          value: '',
          validate: [createValidateObject(validateTypes.REQUIRED)],
          errors: []
        })
      },
      errors: [],
      message: ''
    };
  }

  const initialState = Immutable(stateDefault());
  return function reduce(state = initialState, action = {}) {
    switch (action.type) {
      case createActionName(name, RESET_STATE):
        return Immutable(stateDefault());
      case createActionName(name, CHANGE_SERVICE_ARGS):
        return state.merge({ serviceArgs: action.payload || [] });
      case createActionName(name, SEND_FORM_REQUEST):
        return setRequestStateInProgress(state);
      case createActionName(name, REQUEST_FINISHED):
        return setRequestStateFinish(
          state,
          action.payload.codeResponse,
          action.payload.hasSuccess
        );

      case createActionName(name, SET_ERRORS):
        return storeSetFieldsErrors(state, action.payload);
      case createActionName(name, CLEAR_ALL_ERRORS):
        return clearErrors(state);

      case createActionName(name, CHANGE_MESSAGE):
        return state.merge({
          message: action.payload.message
        });

      case createActionName(name, CHANGE_FIELD_EMAIL): {
        return storeSetFieldValue(state, 'email', action.payload);
      }
      case createActionName(name, CHANGE_FIELD_VERIFY_CODE): {
        return storeSetFieldValue(state, 'verify_code', action.payload);
      }
      default:
        return state;
    }
  };
};

export function createReduceObject(combineName, reducerName) {
  const reduceObject = {};
  reduceObject[reducerName] = createReducer(`${combineName}.${reducerName}`);
  return reduceObject;
}

export const resetState = reducerName => ({
  type: createActionName(reducerName, RESET_STATE)
});
export const changeServiceArgs = (parentName, payload) => ({
  type: createActionName(parentName, CHANGE_SERVICE_ARGS),
  payload
});
export const sendFormRequest = reducerName => ({
  type: createActionName(reducerName, SEND_FORM_REQUEST)
});
export const requestFinished = (reducerName, codeResponse, hasSuccess) => ({
  type: createActionName(reducerName, REQUEST_FINISHED),
  payload: { codeResponse, hasSuccess }
});

export const setErrors = (reducerName, payload) => ({
  type: createActionName(reducerName, SET_ERRORS),
  payload
});
export const clearAllErrors = (reducerName, payload) => ({
  type: createActionName(reducerName, CLEAR_ALL_ERRORS),
  payload
});

export const changeMessage = (reducerName, message) => ({
  type: createActionName(reducerName, CHANGE_MESSAGE),
  payload: { message }
});

// FIELDS
export const changeFieldEmail = (reducerName, payload) => ({
  type: createActionName(reducerName, CHANGE_FIELD_EMAIL),
  payload
});
export const changeFieldVerifyCode = (reducerName, payload) => ({
  type: createActionName(reducerName, CHANGE_FIELD_VERIFY_CODE),
  payload
});

// SELECTOR
export const getState = (state, reducerName) => _.get(state, reducerName);

export const selectRequestState = (state, reducerName) =>
  _.get(getState(state, reducerName), 'requestState');
export const selectFormBody = (state, reducerName) =>
  getForm(getState(state, reducerName));
export const selectAllErrors = (state, reducerName) =>
  _.get(getState(state, reducerName), 'errors');

// Fields
export const selectFieldEmail = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.email');
export const selectFieldVerifyCode = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.verify_code');
export const selectMessage = (state, reducerName) =>
  _.get(getState(state, reducerName), 'message');



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/users/common/reducers/forms/requestPasswordResetForm.js